<template>
  <div class="quest-filter" v-if="filterData !== null">
    <FilterStudentPlatform :selected-filters-count="selectedFiltersCount" @filter-updated="onFilterUpdated"
                           @filter-reset="onFilterReset" @filter-cancelled="resetFilterDraft">
      <FilterCategoryBlock v-for="category in studentPlatformFilterCategories" :key="category.key"
                           :filter-category="category" :block-data="filterDataDraft[category.key]"
                           :visual-style="'student-platform'"
                           @updated="filterBlockUpdated"></FilterCategoryBlock>

      <div class="px-3 pt-3 pb-1 mt-1">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" :id="'filter-include-completed_' + uuid"
                 v-model="filterDataDraft['hideCompletedQuests']"/>
          <label class="form-check-label" :for="'filter-include-completed_' + uuid">Verberg gespeelde
            activiteiten</label>
        </div>
      </div>
    </FilterStudentPlatform>
  </div>
</template>

<script>
import QuestFilterMixin from "@/mixins/QuestFilter";
import log from "@/utils/logger";

import FilterCategoryBlock from "@/components/Filter/FilterCategoryBlock";
import FilterStudentPlatform from "@/components/StudentPlatform/Activities/FilterStudentPlatform";

let uuid = 0;

export default {
  name: "QuestFilter",
  components: { FilterStudentPlatform, FilterCategoryBlock },
  mixins: [ QuestFilterMixin ],
  emits: [ "filter-updated" ],
  data()
  {
    return {
      filterData: null,
      filterDataDraft: null,
    }
  },
  computed: {
    filterIsEmpty()
    {
      let isEmpty = true;

      for (let i = 0; i < this.filterCategories.length; i++)
      {
        if (Object.prototype.hasOwnProperty.call(this.filterData, this.filterCategories[i].key) &&
            this.filterData[this.filterCategories[i].key].length > 0)
        {
          isEmpty = false;
          break;
        }
      }

      if (isEmpty)
      {
        isEmpty = isEmpty && !this.filterData['hideCompletedQuests'];
      }

      return isEmpty;
    },
    selectedFiltersCount()
    {
      let appliedFilters = 0;

      for (const value of Object.values(this.filterDataDraft))
      {
        appliedFilters += value ? value.length : 0;
      }

      return appliedFilters;
    },
    studentPlatformFilterCategories()
    {

      //the activity list of the student platform does not allow filtering on activity type (as that is already done beforehand)
      let categories = this.filterCategories.filter(function(obj)
      {
        return obj.key !== 'questType';
      });

      return categories;

    }
  },
  methods: {
    onFilterReset()
    {
      log.debug("Resetting filter - %o", this.filterDataDraft);
      this.resetFilterData(this.filterDataDraft);
      this.filterData = JSON.parse(JSON.stringify(this.filterDataDraft));
      this.$emit("filter-updated", this.filterData, this.filterIsEmpty);
    },
    resetFilterDraft()
    {
      this.filterDataDraft = JSON.parse(JSON.stringify(this.filterData));
    },
    onFilterUpdated()
    {
      log.debug("Updating quest filter");
      this.filterData = JSON.parse(JSON.stringify(this.filterDataDraft));
      this.$emit("filter-updated", this.filterData, this.filterIsEmpty);
    },
    filterBlockUpdated(updateData)
    {
      console.log(this.filterDataDraft);
      if (updateData && Object.prototype.hasOwnProperty.call(this.filterDataDraft, updateData.category))
      {
        if (updateData.checked)
        {
          if (!this.filterDataDraft[updateData.category].includes(updateData.value))
          {
            this.filterDataDraft[updateData.category].push(updateData.value);
          }
        }
        else
        {
          const valueIndex = this.filterDataDraft[updateData.category].indexOf(updateData.value);
          if (valueIndex > -1)
          {
            this.filterDataDraft[updateData.category].splice(valueIndex, 1);
          }
        }
      }
      console.log(this.filterDataDraft);
    },
    fetchInitialFilters()
    {
      // TODO - fetch initial filters from sessionStorage?
    },
    resetFilterData(filterData)
    {
      for (let i = 0; i < this.filterCategories.length; i++)
      {
        filterData[this.filterCategories[i].key] = [];
      }

      filterData['hideCompletedQuests'] = false;
    }
  },
  created()
  {
    this.fetchInitialFilters();

    if (this.filterData === null)
    {
      this.filterData = {};
      this.resetFilterData(this.filterData);
      this.filterDataDraft = JSON.parse(JSON.stringify(this.filterData));
    }
  },
  beforeCreate()
  {
    this.uuid = uuid.toString();
    uuid += 1;
  }
}
</script>

<style scoped>

</style>